/**
 * Parse user-entered numbers with dot or comma decimal separator.
 * JSON payloads should use native JS numbers (dot only).
 * @param {unknown} raw
 * @returns {number}
 */
export function parseLocaleFloat(raw) {
  if (raw === null || raw === undefined) return NaN;
  const s = String(raw).trim().replace(',', '.');
  if (s === '') return NaN;
  return parseFloat(s);
}
